<template>
  <div>
    <div class="fixed">
      <root-header />
    </div>
    <div class="main">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>

      <router-view v-if="!$route.meta.keepAlive" />
    </div>
    <root-footer />
    <root-tabbar />
  </div>
</template>

<script>
// @ is an alias to /src
import rootHeader from '@/components/layout/RootHeader'
import rootFooter from '@/components/layout/RootFooter'
import rootTabbar from '@/components/layout/RootTabbar'

export default {
  components: {
    rootHeader,
    rootFooter,
    rootTabbar
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">
p {
  margin: 0;
  padding: 0;
}
.center-aligned {
  text-align: center;
}
.center-margin {
  margin: 0 auto;
}
.right-floated {
  float: right;
}
.container {
  width: 1200px;
  margin: 0 auto;
}
.inline-block {
  display: inline-block;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.fixed {
  position: fixed;
  width: 100%;
  height: 110px;
  top: 0px;
  left: 0px;
  z-index: 1900;
}
.main {
  position: relative;
  padding-top: 110px;
}
</style>
